import styled from 'vue-styled-components'
import colors from '@/components/kit/theme'

// use <paragraph :background="'white'" :background-opacity="'30'" :border="'black'" :text="'black'"></paragraph>

const componentProps = {
  background: String,
  backgroundOpacity: Number,
  border: String,
  borderRadius: String,
  color: String,
  applyStyleTo: String
}

const Paragraph = styled('p', componentProps)`
  &${(props) => (props.applyStyleTo ? ` ${props.applyStyleTo}` : '')} {
    background-color: ${(props) =>
      props.backgroundOpacity == null
        ? colors.knownColor(props.background)
        : colors.knownColorWithOpacity(
            props.background,
            props.backgroundOpacity
          )};
    border: ${(props) => (props.border == null ? '' : '1px solid')}
      ${(props) =>
        props.border == null ? '' : colors.knownColor(props.border)};
    border-color: ${(props) => colors.knownColor(props.border)};
    color: ${(props) => colors.knownColor(props.color)};
    border-radius: ${(props) => props.borderRadius};
  }
`

export default {
  props: {
    background: String,
    backgroundOpacity: Number,
    border: String,
    borderRadius: String,
    color: String,
    applyStyleTo: String
  },
  render(h) {
    return (
      <Paragraph
        class="color"
        background={this.background}
        background-opacity={this.backgroundOpacity}
        border={this.border}
        border-radius={this.borderRadius}
        color={this.color}
        apply-style-to={this.applyStyleTo}
      >
        {this.$slots.default}
      </Paragraph>
    )
  }
}
